<template>
  <v-layout row>
    <v-flex md12>
      <v-card>
        <v-toolbar dense primary-title>
          <v-toolbar-title>
            {{$t('view.perfil.registros.label')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="view.elem.showTable = !view.elem.showTable">
            <v-icon>{{ view.elem.showTable ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
          </v-btn>
        </v-toolbar>
        <v-slide-y-transition>
        <v-card-text v-show="view.elem.showTable">
          <v-layout row class="table-responsive">
            <v-flex md12>
              <table id="something" class="table table-striped table-bordered table-hover responsive nowrap dataTables-example" style="width:100%;" >
                <thead>
                  <tr>
                    <th class="all">{{$t('view.global.common.clave')}}</th>
                    <th class="all">{{$t('view.comercio.numeroComercio')}}</th>
                    <th class="all">{{$t('view.comercio.name')}}</th>
                    <th class="desktop">{{$t('view.comercio.tipoArchivo')}}</th>
                    <!--  -->
                    <th class="none">Archivo</th>
                    <th class="all">{{$t('view.global.th.accion.text')}}</th>
                  </tr>
                </thead>
              </table>
            </v-flex>
          </v-layout>
        </v-card-text>
        </v-slide-y-transition>
      </v-card>
    </v-flex>
    
  </v-layout>
</template>
<script>
import ComercioAPI from "@/services/generales/comercio";
import ArchivoAPI from "@/services/archivo";
import {getErrors,getBusinessCode,handleResponseMessage} from '@/helpers/http-response-handler';
import tippy from 'tippy.js';
import {getAccounting} from '@/helpers/form-common';
import {EventBus} from '@/events/event-bus';
import * as dateMethods from "@/helpers/date-methods";
import * as events from '@/constants/event-names';


export default {
  data() {
    return {
      count:0
      , dataTable:undefined
      , view:{
        elem:{
          showTable: true
        }     
      }
    }
  }
  , props:{
    pageLength:{
      default:10
      , type:Number
    }
    , responsive:{
      default:true
      , type:Boolean
    }
    , dom:{
      default:'<"html5buttons"B>lTfgitp'
    } 
  }
  ,methods: {
    async deleteRow(clave){
      try{
        const swalResponse = await this.$swal({
          title: this.$t('view.global.swal.disable.title')
          , text: this.$t('view.global.swal.disable.text')
          , type: this.$t('view.global.swal.disable.type')
          , showCancelButton: this.$t('view.global.swal.disable.showCancelButton')
          , confirmButtonColor: this.$t('view.global.swal.disable.confirmButtonColor')
          , cancelButtonColor: this.$t('view.global.swal.disable.cancelButtonColor')
          , confirmButtonText: this.$t('view.global.swal.disable.confirmButtonText')
          , cancelButtonText: this.$t('view.global.swal.disable.cancelButtonText')
          , reverseButtons: true
        });
        if(swalResponse.value){
          const response = await ComercioAPI.disable({clave});
          handleResponseMessage({response: response,modulo:'Comercio'});
        }
      }catch(error){
        console.log(error);
      }
    }
    , async uploadRow(clave){
      if(this.$userPermission.hasPermission('ROLE_REENVIO_ARCHIVO')){
        try{
          const swalResponse = await this.$swal({
            title: this.$t('view.global.swal.upload.title') , text: this.$t('view.global.swal.upload.text')
            , type: this.$t('view.global.swal.upload.type') , showCancelButton: this.$t('view.global.swal.upload.showCancelButton')
            , confirmButtonColor: this.$t('view.global.swal.upload.confirmButtonColor')
            , cancelButtonColor: this.$t('view.global.swal.upload.cancelButtonColor')
            , confirmButtonText: this.$t('view.global.swal.upload.confirmButtonText')
            , cancelButtonText: this.$t('view.global.swal.upload.cancelButtonText')
            , reverseButtons: true
          });
          if(swalResponse.value){
            try{
              const response = await ArchivoAPI.upload({clave});
              handleResponseMessage({ response,modulo:'Archivo'});
            }catch(error){
              console.error(error)
            }
          }
        }catch(error){}
      }else{
        EventBus.$emit(events.MESSAGES, {type:'error',message: getErrors('Archivo','No cuenta con privilegios para el reenvío de archivos',null)});
      }
    }
    , refreshData(){
      this.dataTable._fnAjaxUpdate();
    }
  }
  , computed:{}
  , components: {
  }
  // Instance Lifecycle Hooks
  , created(){

  }
  , mounted(){
    const vm = this;
    
    function formatDate( date, params ) {
      if(date != null)
      {
        var options = { year: "numeric" , month: "2-digit" , day: "2-digit" , hour:"2-digit" , minute:"2-digit" , second:"2-digit"};
        if(params) {
            options = Object.assign( options, params );
        }
        return new Date( date ).toLocaleString( 'es-MX', options );
      }
      else 
      {
        return '';
      }
    };
    function emitEventDetailRow(event){
      const {id} = this;
      vm.$emit('comercioRow', id);
    };

    function emitEventLogRow(event){
      const {id} = this;
      vm.$emit('logFileRow', id);
    };

    function emitEventDownloadFileRow(event){
      const {id} = this;
      vm.$emit('downloadFileRow', id);
    }

     function emitEventDownloadFileDasRow(event){
      const {id} = this;
      vm.$emit('downloadFileDasRow', id);
    }

    function emitEventUploadDasWithErrorRow(event){
      const {id} = this;
      vm.$emit('uploadDasWithErrorRow', id);
    }

    function emitEventReprocesarRespuesta(event){
      const {id} = this;
      vm.$emit('reprocesarRespuesta', id);
    }

    function emitEventUploadRow(event){
      const {id} = this;
      vm.uploadRow(id)
      .then(response=>{
        vm.dataTable._fnAjaxUpdate();
      })
      .catch(console.log);
    }

    function newDetailButton(id,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Detalle");
      button.classList.add('btn', 'btn-action-delete', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.id = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'fa', 'fa-search');
      //label settings
      label.appendChild(document.createTextNode('detail'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    }

    function newReRunResponseButton(id,eventFunction){
      //const button = document.createElement('button');
      const link = document.createElement('i');
      //button settings
      link.setAttribute("title","Volver a procesar");
      link.classList.add('emitEventReprocesarRespuesta');
      link.id = id || "";
      //link.onclick = eventFunction;
      //link
      link.classList.add('v-icon', 'btn', 'tool', 'primary--text', 'mdi', 'mdi-replay');
      //label settings
      //label.appendChild(document.createTextNode('rerun'))
      //Append link and label within the button
      //button.appendChild(link);
      //button.appendChild(label);
      
      return link;
    }

    function createTH(textContent, sClass){
      let th = document.createElement('th');
      th.textContent = textContent;
      // th.classList.add('');
      if(sClass != undefined && sClass != null && sClass != ''){
        th.classList.add(sClass);
      }
      return  th;
    }

    function createTD(value, sClass,isHTML){
      const td = document.createElement('td');
      if(!isHTML)
        td.textContent = value;
      else
        td.appendChild(value)
      // td.classList.add('');
      if(sClass != undefined && sClass != null && sClass != ''){
        td.classList.add(sClass);
      }
      
      return td;
    };

    function newLogButton(id,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Descargar Log");
      button.classList.add('btn', 'btn-action-delete', 'button', 'button--sacnite', 'button--round-l', 'custom', 'emitEventDetailRow');
      button.id = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'fa', 'fa-file');
      //label settings
      label.appendChild(document.createTextNode('detail'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    }

    function expandDataTableRegs(event) {
      if($('#expandir-chevron').hasClass('fa-chevron-up')){
        $('#btnExpandirDatatable').attr('state',false);
        $('#btnExpandirDatatable').find('span').text("Contraer todo");
        $('#expandir-chevron').removeClass('fa-chevron-up');
        $('#expandir-chevron').addClass('fa-chevron-down');
        vm.dataTable.find('tbody').find('tr[role="row"]:not(.parent)').find('td.sorting_1').click();
      } 
      else{
        $('#btnExpandirDatatable').attr('state',true);
        $('#btnExpandirDatatable').find('span').text("Expandir todo");
        $('#expandir-chevron').removeClass('fa-chevron-down');
        $('#expandir-chevron').addClass('fa-chevron-up');
        vm.dataTable.find('tbody').find('tr.parent').find('td.sorting_1').click();
      }
    }
    
    const createTableFilesVanilla = ( files )=> {
      let tabla = document.createElement('table');
      if(Array.isArray(files)){  
        tabla.style.width='100%';
        tabla.classList.add('table','table-striped', 'table-hover', 'table-sm', 'responsive');
        const thead = document.createElement('thead');
        const tr = document.createElement('tr');
        tr.appendChild(new createTH('Estado'));
        tr.appendChild(new createTH(''));
        tr.appendChild(new createTH('Nombre'))
        tr.appendChild(new createTH(vm.$t('view.comercio.numeroComercio')))
        tr.appendChild(new createTH('Tipo'))
        tr.appendChild(new createTH('Proceso'))
        tr.appendChild(new createTH('Método'))
        tr.appendChild(new createTH('Ejec.'))
        tr.appendChild(new createTH('Fecha'))
        tr.appendChild(new createTH('Registros'))
        tr.appendChild(new createTH('Total'))
        thead.appendChild(tr);
        tabla.appendChild(thead)
        const tbody = document.createElement('tbody');
        let tableContent = '';
        files.forEach(file => {
          const trBody = document.createElement('tr');
          let iconProceso ='';
          let iconEjecucion = '';
          let iconInterfaz = '';
          let iconConversionCorrecta = '';
          let iconCheck='';
          let tooltip='';
          let iconGetLog = '';
          let descargarArchivo = '';
          let rerunResponse = '';
          if(file.proceso === "DOWNLOADER"){
            iconProceso = document.createElement('i');
            iconProceso.setAttribute("title",file.proceso)
            iconProceso.classList.add('v-icon', 'tool', 'primary--text', 'mdi', 'mdi-cloud-download')
            iconCheck = 'check'
            tooltip = 'Descargado y Procesado'
          }
            
          if(file.proceso=== "CONVERTER"){
            iconProceso =  document.createElement('i');
            iconProceso.setAttribute("title",file.proceso)
            iconProceso.setAttribute("id",`${file.clave}`);
            iconProceso.classList.add('v-icon', 'tool', 'primary--text', 'mdi', 'mdi-atom')            
            iconCheck = 'check-all'
            tooltip = 'Convertido'
            const eventUploadDasWithError = (file.tipoEjecucion === "RESPUESTA" && !file.isConversionExitosa) ? 'emitEventUploadDasWithErrorRow' : '';
            if(eventUploadDasWithError !== '')
              iconProceso.classList.add(eventUploadDasWithError) ;
            
          }
            
          if(file.proceso === "UPLOADER"){
            iconProceso =  document.createElement('i');
            iconProceso.setAttribute("title",file.proceso);
            iconProceso.setAttribute("id",`${file.clave}`);
            iconProceso.classList.add('v-icon', 'tool', 'primary--text', 'mdi', 'mdi-cloud-upload', 'emitEventUploadRow');
            iconCheck = 'cloud-check';
            tooltip = 'Enviado';
            //iconProceso.classList.add("emitEventDownloadFileDasRow");           
          }
          
          if(file.tipoEjecucion === "PETICION"){
            iconEjecucion =  document.createElement('i');
            iconEjecucion.setAttribute("title",file.tipoEjecucion)
            iconEjecucion.setAttribute("id",`${file.clave}`);
            iconEjecucion.classList.add('v-icon', 'tool', 'primary--text', 'mdi', 'mdi-file-send')
            //y  if(file.proceso === "UPLOADER"){ agregar link descarda DasLib.json
            if(file.proceso === "UPLOADER")
              iconEjecucion.classList.add('btn','emitEventDownloadFileDasRow');
              //iconEjecucion.classList.add("emitEventDownloadFileDasRow")
            // iconEjecucion = ' <i title="'+file.tipoEjecucion+'" class="v-icon tool primary--text mdi mdi-file-send mdi-24px" ></i>'
          }else{
            iconEjecucion =  document.createElement('i');
            iconEjecucion.setAttribute("title",file.tipoEjecucion);
            iconEjecucion.setAttribute("id",`${file.clave}`);
            iconEjecucion.classList.add('v-icon', 'tool', 'primary--text', 'mdi', 'mdi-file-undo');
            //y  if(file.proceso === "UPLOADER"){ agregar link descarda DasLib.json
            if(file.proceso === "CONVERTER")
              iconEjecucion.classList.add( 'btn','emitEventDownloadFileDasRow');
            // iconEjecucion = ' <i title="'+file.tipoEjecucion+'" class="v-icon tool primary--text mdi mdi-file-undo mdi-24px" ></i>'
          }
          if(file.interfaz  === "SCHEDULED") {
            iconInterfaz =  document.createElement('i');
            iconInterfaz.setAttribute("title",file.interfaz);
            iconInterfaz.classList.add('v-icon', 'tool', 'primary--text', 'mdi', 'mdi-calendar-clock');
            // iconInterfaz =  ' <i title="'+file.interfaz+'" class="v-icon tool primary--text mdi mdi-calendar-clock mdi-24px" ></i>'
          }else{
            iconInterfaz =  document.createElement('i');
            iconInterfaz.setAttribute("title",file.interfaz);
            iconInterfaz.classList.add('v-icon', 'tool', 'primary--text', 'mdi', 'mdi-sync-alert');
            // iconInterfaz =  ' <i title="'+file.interfaz+'" class="v-icon tool primary--text mdi mdi mdi-sync-alert mdi-24px" ></i>'
          }
          if(file.isConversionExitosa) {
            iconConversionCorrecta =  document.createElement('i');
            if(file.proceso === "CONVERTER"){
              iconConversionCorrecta.setAttribute("title",`Descarga Log<br>${tooltip}`);
              iconConversionCorrecta.setAttribute("id",`${file.clave}`);
              iconConversionCorrecta.classList.add( 'btn' , 'emitEventLogRow');
            }else{
              iconConversionCorrecta.setAttribute("title",tooltip);
              iconConversionCorrecta.classList.add('tool');
            }
            iconConversionCorrecta.classList.add('v-icon', 'success--text', 'mdi', `mdi-${iconCheck}`);
          }else{
            iconConversionCorrecta =  document.createElement('i');
            if(file.proceso === "CONVERTER"){
              iconConversionCorrecta.setAttribute("title",`Descarga Log<br>${tooltip}`);
              iconConversionCorrecta.setAttribute("id",`${file.clave}`);
              iconConversionCorrecta.classList.add( 'btn' , 'emitEventLogRow');
            }else{
              iconConversionCorrecta.setAttribute("title",'Descargado Pendiente de Procesar');
              iconConversionCorrecta.classList.add( 'tool');
            }
            iconConversionCorrecta.classList.add('v-icon', 'warning--text', 'mdi', 'mdi-alert-circle');
          }

          if (file.estatusConversion === 'Error'){
            iconConversionCorrecta =  document.createElement('i');
            iconConversionCorrecta.setAttribute("title",`Descarga Log<br>${file.mensajeConversion}`);
            iconConversionCorrecta.setAttribute("id",`${file.clave}`);
            iconConversionCorrecta.classList.add('v-icon', 'btn', 'error--text', 'mdi', 'mdi-close-octagon', 'emitEventLogRow');
          }
          // let nombreArchivo = file.encriptado ? file.nombreArchivoEncriptado:file.name
          
          trBody.appendChild(new createTD(iconConversionCorrecta, 'text-md-center',true));

          if(file.proceso === "CONVERTER" 
              && file.tipoEjecucion === "RESPUESTA"  
              && vm.$userPermission.hasPermission('ROLE_REPROCESO_RESPUESTA')){
                trBody.appendChild(new createTD(new newReRunResponseButton(file.clave,emitEventReprocesarRespuesta), 'text-md-center',true))               
          }else{
            trBody.appendChild(new createTD(document.createElement('p'), 'text-md-center',true))
          }
          
          if(file.proceso != "UPLOADER" 
          && (!file.status || (file.estatusConversion === 'Error') || (file.name.includes('AUTHACCEPT', 0) || file.name.includes('AUTHREJECT', 0) ))
          && vm.$userPermission.hasPermission('ROLE_DESCARGAR_ARCHIVO')){
            descargarArchivo = document.createElement('a');
            descargarArchivo.setAttribute("id",`${file.clave}`);
            descargarArchivo.classList.add("emitEventDownloadFileRow")
            descargarArchivo.appendChild(document.createTextNode(file.name))
            trBody.appendChild(new createTD(descargarArchivo,'text-md-left',true ))
          }else{
            trBody.appendChild(new createTD(file.name ))
          }
          
          trBody.appendChild(new createTD(file.numeroComercio ))
          trBody.appendChild(new createTD(iconProceso, 'text-md-center',true))
          trBody.appendChild(new createTD(iconEjecucion, 'text-md-center',true))
          trBody.appendChild(new createTD(iconInterfaz, 'text-md-center',true))
          trBody.appendChild(new createTD(file.tipoArchivo))
          trBody.appendChild(new createTD(dateMethods.formatDateTime(file.fechaalta)))
          trBody.appendChild(new createTD((file.numeroRegistros == null ? 0 : file.numeroRegistros)))
          trBody.appendChild(new createTD(getAccounting().formatMoney(file.montoTotal)))
          tbody.appendChild(trBody);
        });
        tabla.appendChild(tbody);
      }
      if(tabla == ''){
        tabla = document.createElement('p');
      }

      return tabla;
    }
    this.$nextTick(function(){
      
      vm.dataTable = window.$('#something').dataTable({     
        "bProcessing": true
        , "bServerSide": true
        , "bPaginate":true
        , "pageLength" : vm.pageLength
        , "responsive": true
        , "language": { "url": '/static/js/dataTables/language/dataTables.spanish.json' }
        , "ajax":{
          "url": "/api/comercio/listBitacoraComercioArchivos"
          , "type": "POST"
          , "async":true
          , "headers": { "Authorization":`Bearer ${vm.$store.getters.getUserToken}` }
          , "data"    : function(data){
            let {nombreArchivo,fecha,tipoArchivo,comercio} =  vm.$parent.bitacora;
            let objFilter = {};
            if(comercio != null ){
              objFilter['clave'] = comercio.code;
            }

            if(nombreArchivo != null && nombreArchivo != '')
              objFilter['nombreArchivo'] = nombreArchivo;
            
            if(tipoArchivo != null && tipoArchivo !== ''){
              objFilter['tipoArchivo'] = tipoArchivo.code;
            }
            if(fecha != null && fecha !== ''){
              objFilter['fecha'] = fecha;
            }
            data.filtros = JSON.stringify(objFilter);
            
              
          }
          , "complete": function(response){}
          , "error"   : function(error){}
        }
        , "fnRowCallback": function( nRow, aData, iDisplayIndex, iDisplayIndexFull ) {
          nRow.cells[5].textContent = null;
          nRow.cells[5].appendChild(newDetailButton(nRow.cells[0].innerText, emitEventDetailRow));
          
        }
        , "fnDrawCallback": function (oSettings) {

          //mdl-button  mdl-button--raised mdl-button--colored
          tippy('.btn , .tool', { arrow: true, arrowType: 'round', size: 'large', animation: 'scale' });
          $('#btnExpandirDatatable').parent().remove();
          $('#btnExpandirDatatable').remove();
          $('<div style="text-align: center;">').append(
            $('<button>')
              .css("border-radius", "10px")
              .addClass('btn')
              .addClass('btn-primary')
              .addClass('btn-xs')
              .addClass('dataTables_expand')
              .attr('id','btnExpandirDatatable')
              .attr('state',true)
              .append('<span>' + "Expandir todo" + '</span>')
              .append('<i id="expandir-chevron" style="margin-left:8px; font-size:10px;" class="fa fa-chevron-up"></i>')
            ).addClass('col-sm-12').addClass('col-md-4').addClass('col-lg-4').insertAfter($('#something_length').parent());
            
          $('#btnExpandirDatatable').click(function(e){
            e.preventDefault();
            expandDataTableRegs();
            return false;
          });

          
          $('.dataTables_length').parent()
          .removeClass('mdl-cell')
          .removeClass('mdl-cell--6-col')
          .addClass('col-sm-12').addClass('col-md-4').addClass('col-lg-4');

          $('.dataTables_filter').parent()
          .removeClass('mdl-cell')
          .removeClass('mdl-cell--6-col')
          .addClass('col-sm-12').addClass('col-md-4').addClass('col-lg-4');
        }
        , "aaSorting" : [[0, 'desc']]
        , "aoColumns": [
          {
            "data":"clave"
            , "sClass":"text-center"
          }
          , {
            "data":"numeroComercio"
            , "sClass":"text-center"
          } 
          , {
            "data":"name"
            , "sClass":"text-center"
          }          
          , {
            "data":"tipoArchivo"
            , "sClass":"text-center"
          }
          , {
            "data": "archivos"
            , "sClass":"text-center none"
          }
          , {
            "data": "status"
            , "sClass":"text-center"
          }
        ]
        , "aoColumnDefs":[
          {
            "aTargets": [ 4 ],
            "mData": "archivos",
            "searchable": false,
            "sorting": false,
            "orderable": false,
            "mRender": function ( data, type, full ) {
              let tableFiles = createTableFilesVanilla(data);
              let wrap = document.createElement('div');
              wrap.appendChild(tableFiles);
              return wrap.innerHTML;
            }
          }
          , {
            "aTargets": [ 5 ],
            "mData": "status",
            "searchable": false,
            "sorting": false,
            "orderable": false,
            "className":"text-center",
            "mRender": function ( data, type, full ) {
              return data;
            }
          }
        ]
      });
      
      $('#something tbody').click( function () {
        tippy('.btn , .tool', { arrow: true, arrowType: 'round', size: 'large', animation: 'scale' });
      });

      $(document).off('click','.emitEventLogRow');
      $(document).on('click','.emitEventLogRow',emitEventLogRow);

      $(document).off('click','.emitEventDownloadFileRow');
      $(document).on('click','.emitEventDownloadFileRow',emitEventDownloadFileRow);

      $(document).off('click','.emitEventDownloadFileDasRow');
      $(document).on('click','.emitEventDownloadFileDasRow',emitEventDownloadFileDasRow);

      $(document).off('click','.emitEventUploadRow');
      $(document).on('click','.emitEventUploadRow',emitEventUploadRow);

      $(document).off('click','.emitEventUploadDasWithErrorRow');
      $(document).on('click','.emitEventUploadDasWithErrorRow',emitEventUploadDasWithErrorRow);

      $(document).off('click','.emitEventReprocesarRespuesta');
      $(document).on('click','.emitEventReprocesarRespuesta',emitEventReprocesarRespuesta);
      
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/views/bitacoras/documento/DataTable.vue